export const Circle = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 8 9"
      fill={props.color || "none"}
    >
      <circle
        cx="4"
        cy="4.5"
        r="3.5"
        stroke={props.stroke ? props.stroke : "#404040"}
        strokeOpacity={props.strokeOpacity ? props.strokeOpacity : "0.5"}
      />
    </svg>
  );
};

export const PetitionIcon = (props) => {
  return (
    <svg
      width={props.width || "21"}
      height={props.height || "20"}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.86366 8.17587C6.86366 7.76508 7.19667 7.43207 7.60746 7.43207H13.3926C13.8034 7.43207 14.1364 7.76508 14.1364 8.17587C14.1364 8.58666 13.8034 8.91968 13.3926 8.91968H7.60746C7.19667 8.91968 6.86366 8.58666 6.86366 8.17587Z"
        fill={props.color || "#4362EA"}
      />
      <path
        d="M6.86366 11.8222C6.86366 11.4115 7.19667 11.0784 7.60746 11.0784H13.3926C13.8034 11.0784 14.1364 11.4115 14.1364 11.8222C14.1364 12.233 13.8034 12.566 13.3926 12.566H7.60746C7.19667 12.566 6.86366 12.233 6.86366 11.8222Z"
        fill={props.color || "#4362EA"}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.5005 2.32078C9.49716 1.78125 8.31077 1.71783 7.25246 2.15556C6.19452 2.59313 5.39923 3.47512 5.07081 4.56904C3.97691 4.89746 3.09492 5.69273 2.65734 6.75068C2.22098 7.80566 2.27964 8.99232 2.82254 9.99875C2.27966 11.0052 2.22097 12.1918 2.65733 13.2468C3.09414 14.3029 3.97497 15.1011 5.07081 15.4302C5.39886 16.5228 6.19271 17.4041 7.24887 17.8421C7.7187 18.0379 8.21252 18.1333 8.70454 18.1333C9.32289 18.1333 9.94055 17.9812 10.5006 17.6784C11.5039 18.218 12.6903 18.2814 13.7486 17.8436C14.8065 17.4061 15.6018 16.5241 15.9302 15.4302C17.0261 15.1011 17.9069 14.3029 18.3437 13.2468C18.7806 12.1906 18.7208 11.0057 18.1785 9.99873C18.7177 8.99597 18.7818 7.80767 18.3434 6.75005C17.9058 5.69243 17.0239 4.89739 15.9302 4.56904C15.6018 3.47513 14.8065 2.59315 13.7486 2.15556C12.6936 1.71921 11.5069 1.77787 10.5005 2.32078ZM14.5104 14.9856C14.3133 15.6602 13.8291 16.2005 13.18 16.469C12.5309 16.7374 11.8055 16.6967 11.1904 16.3602C10.7588 16.1241 10.2423 16.1241 9.81068 16.3602C9.46574 16.5505 9.08514 16.6457 8.70454 16.6457C8.40554 16.6457 8.10648 16.5879 7.82103 16.469C7.17196 16.2005 6.68772 15.6602 6.49062 14.9856C6.353 14.5133 5.98767 14.148 5.51533 14.0103C4.84078 13.8133 4.30045 13.3273 4.03199 12.6782C3.76353 12.0292 3.80261 11.3037 4.14073 10.6886C4.37691 10.257 4.37691 9.74048 4.14073 9.30891C3.80261 8.69386 3.76353 7.96832 4.03199 7.31926C4.30046 6.67019 4.84078 6.18595 5.51533 5.98885C5.98771 5.85123 6.35299 5.4859 6.49062 5.01356C6.68771 4.33901 7.17196 3.79868 7.82103 3.53022C8.47009 3.26176 9.19558 3.30254 9.81068 3.63896C10.2423 3.87514 10.7588 3.87514 11.1904 3.63896C11.8054 3.30084 12.5309 3.26176 13.18 3.53022C13.8291 3.79868 14.3133 4.33901 14.5104 5.01356C14.648 5.48594 15.0134 5.85122 15.4857 5.98885C16.1603 6.18594 16.7006 6.67019 16.9691 7.31926C17.2375 7.96663 17.1967 8.69381 16.8603 9.30891C16.6241 9.74048 16.6241 10.257 16.8603 10.6886C17.1984 11.3054 17.2375 12.0292 16.9691 12.6782C16.7006 13.3273 16.1603 13.8132 15.4857 14.0103C15.0133 14.148 14.648 14.5133 14.5104 14.9856Z"
        fill={props.color || "#4362EA"}
      />
    </svg>
  );
};

export const ErrorIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.47396 6.82353C7.47396 6.5528 7.70948 6.33333 8 6.33333C8.29052 6.33333 8.52604 6.5528 8.52604 6.82353V8.78431C8.52604 9.05504 8.29052 9.27451 8 9.27451C7.70948 9.27451 7.47396 9.05504 7.47396 8.78431V6.82353Z"
        fill="#FF0000"
      />
      <path
        d="M8 9.86274C7.70948 9.86274 7.47396 10.0822 7.47396 10.3529C7.47396 10.6237 7.70948 10.8431 8 10.8431C8.29052 10.8431 8.52604 10.6237 8.52604 10.3529C8.52604 10.0822 8.29052 9.86274 8 9.86274Z"
        fill="#FF0000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7653 10.5962L13.7682 10.6009C14.4348 11.6837 13.58 13 12.2719 13H3.72807C2.41997 13 1.56522 11.6838 2.23184 10.6009L2.23474 10.5962L6.51054 3.7972C6.66259 3.55357 6.88045 3.35267 7.14088 3.21336C7.40278 3.07327 7.69912 3 8 3C8.30088 3 8.59723 3.07327 8.85912 3.21336C9.11958 3.35268 9.33745 3.55361 9.48949 3.79725L13.7653 10.5962ZM8.39884 4.38982L12.6731 11.1864C12.8483 11.471 12.627 11.8235 12.2719 11.8235H3.72807C3.37303 11.8235 3.15171 11.471 3.32692 11.1864L7.60116 4.38982C7.64132 4.32501 7.69936 4.27114 7.7694 4.23367C7.83945 4.19621 7.919 4.17647 8 4.17647C8.081 4.17647 8.16055 4.19621 8.2306 4.23367C8.30064 4.27114 8.35868 4.32501 8.39884 4.38982Z"
        fill="#FF0000"
      />
    </svg>
  );
};

export const RotateIcon = (props) => {
  return (
    <svg
      width={props.width || "14"}
      height={props.height || "16"}
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6 1.8337C11.2234 0.646152 9.4897 -0.00254483 7.70033 0.000498944C6.00088 0.000374291 4.34933 0.583725 3.00266 1.66087C1.65613 2.73805 0.690298 4.24766 0.255917 5.95463C-0.178584 7.66172 -0.0573301 9.4702 0.600781 11.098C1.25901 12.726 2.4169 14.0819 3.89434 14.9545C5.37147 15.8272 7.08524 16.1675 8.76823 15.9226C10.4511 15.6776 12.0088 14.8609 13.1984 13.6C13.3328 13.4633 13.4087 13.276 13.4087 13.0806C13.4088 12.8851 13.3331 12.6978 13.1988 12.561C13.0645 12.4241 12.8828 12.3493 12.6947 12.3531C12.5066 12.357 12.328 12.4395 12.199 12.5818C11.6143 13.2058 10.9146 13.7011 10.1417 14.0384C9.36891 14.3758 8.53867 14.5482 7.70047 14.5454C6.35161 14.5454 5.03833 14.0956 3.95393 13.2623C2.86951 12.4291 2.07117 11.2559 1.67638 9.91603C1.28158 8.57619 1.31113 7.13989 1.76075 5.81864C2.21025 4.4975 3.05618 3.36095 4.17387 2.5765C5.29153 1.79206 6.622 1.40112 7.96961 1.46102C9.31715 1.52105 10.6106 2.02875 11.6597 2.90963H10.5001C10.25 2.90963 10.019 3.04817 9.89393 3.27318C9.7689 3.49818 9.7689 3.77553 9.89393 4.00052C10.019 4.22552 10.25 4.36407 10.5001 4.36407H13.3001C13.4857 4.36407 13.6637 4.28749 13.7949 4.15113C13.9263 4.01477 14 3.8297 14 3.63685V0.727844C14 0.468024 13.8665 0.227935 13.65 0.0980248C13.4334 -0.031885 13.1666 -0.031885 12.95 0.0980248C12.7335 0.227935 12.6 0.468028 12.6 0.727844V1.8337Z"
        fill={props.color ? props.color : "white"}
      />
      {!props.removeDot && (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.72042 9.02898L6.71038 10.0575C6.97311 10.3299 7.3291 10.4828 7.70022 10.4828C8.07133 10.4828 8.42733 10.3299 8.69005 10.0575L9.68001 9.02898C9.94216 8.75601 10.0893 8.38613 10.0893 8.00055C10.0893 7.61496 9.94215 7.24508 9.68001 6.97212L8.69005 5.94356C8.42733 5.67122 8.07133 5.51818 7.70022 5.51818C7.3291 5.51818 6.9731 5.6712 6.71038 5.94356L5.72042 6.97212C5.4583 7.24509 5.311 7.61496 5.311 8.00055C5.311 8.38613 5.45829 8.75601 5.72042 9.02898Z"
          fill={props.color ? props.color : "white"}
        />
      )}
    </svg>
  );
};

export const SuccessIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "12"}
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33339 11.3684C5.66067 11.7173 6.1913 11.7173 6.51858 11.3684L15.4074 1.89476C15.7347 1.54595 15.7347 0.980413 15.4074 0.631602C15.0802 0.282792 14.5495 0.282793 14.2223 0.631604L6.5186 8.8421C6.19132 9.19091 5.6607 9.19091 5.33342 8.8421L1.77781 5.05257C1.45053 4.70375 0.919908 4.70376 0.592628 5.05257C0.26535 5.40138 0.265347 5.96691 0.592624 6.31572L5.33339 11.3684Z"
        fill="#00a000"
      />
    </svg>
  );
};

export const CloseIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M4.16784 4.16784C4.22091 4.11464 4.28396 4.07243 4.35336 4.04363C4.42277 4.01482 4.49718 4 4.57233 4C4.64747 4 4.72188 4.01482 4.79129 4.04363C4.8607 4.07243 4.92374 4.11464 4.97681 4.16784L8.00015 7.19233L11.0235 4.16784C11.0766 4.11472 11.1397 4.07259 11.2091 4.04384C11.2785 4.0151 11.3529 4.0003 11.428 4.0003C11.5031 4.0003 11.5775 4.0151 11.6469 4.04384C11.7163 4.07259 11.7793 4.11472 11.8325 4.16784C11.8856 4.22096 11.9277 4.28402 11.9565 4.35342C11.9852 4.42282 12 4.49721 12 4.57233C12 4.64744 11.9852 4.72183 11.9565 4.79123C11.9277 4.86063 11.8856 4.92369 11.8325 4.97681L8.80797 8.00015L11.8325 11.0235C11.8856 11.0766 11.9277 11.1397 11.9565 11.2091C11.9852 11.2785 12 11.3529 12 11.428C12 11.5031 11.9852 11.5775 11.9565 11.6469C11.9277 11.7163 11.8856 11.7793 11.8325 11.8325C11.7793 11.8856 11.7163 11.9277 11.6469 11.9565C11.5775 11.9852 11.5031 12 11.428 12C11.3529 12 11.2785 11.9852 11.2091 11.9565C11.1397 11.9277 11.0766 11.8856 11.0235 11.8325L8.00015 8.80797L4.97681 11.8325C4.92369 11.8856 4.86063 11.9277 4.79123 11.9565C4.72183 11.9852 4.64744 12 4.57233 12C4.49721 12 4.42282 11.9852 4.35342 11.9565C4.28402 11.9277 4.22096 11.8856 4.16784 11.8325C4.11472 11.7793 4.07259 11.7163 4.04384 11.6469C4.0151 11.5775 4.0003 11.5031 4.0003 11.428C4.0003 11.3529 4.0151 11.2785 4.04384 11.2091C4.07259 11.1397 4.11472 11.0766 4.16784 11.0235L7.19233 8.00015L4.16784 4.97681C4.11464 4.92374 4.07243 4.8607 4.04363 4.79129C4.01482 4.72188 4 4.64747 4 4.57233C4 4.49718 4.01482 4.42277 4.04363 4.35336C4.07243 4.28396 4.11464 4.22091 4.16784 4.16784Z"
        fill={props.color ? props.color : "#404040"}
      />
    </svg>
  );
};

export const ValidIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.22275 11.5C6.96616 11.7478 6.55014 11.7478 6.29355 11.5L3.19238 8.5C2.93579 8.25218 2.93579 7.85038 3.19239 7.60256C3.44898 7.35473 3.865 7.35473 4.12159 7.60256L6.29357 9.7051C6.55016 9.95292 6.96618 9.95292 7.22277 9.7051L11.455 5.18587C11.7116 4.93805 12.1277 4.93804 12.3843 5.18587C12.6408 5.43369 12.6408 5.83549 12.3843 6.08331L7.22275 11.5Z"
        fill="#4E4E4E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM14.8 8C14.8 11.7555 11.7555 14.8 8 14.8C4.24446 14.8 1.2 11.7555 1.2 8C1.2 4.24446 4.24446 1.2 8 1.2C11.7555 1.2 14.8 4.24446 14.8 8Z"
        fill="#4E4E4E"
      />
    </svg>
  );
};

export const InfoIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.3 10.1H8.7V11.5H7.3V10.1ZM7.3 4.5H8.7V8.7H7.3V4.5ZM8 1C4.129 1 1 4.15 1 8C1 9.85651 1.7375 11.637 3.05025 12.9497C3.70026 13.5998 4.47194 14.1154 5.32122 14.4672C6.17049 14.8189 7.08075 15 8 15C9.85651 15 11.637 14.2625 12.9497 12.9497C14.2625 11.637 15 9.85651 15 8C15 7.08075 14.8189 6.17049 14.4672 5.32122C14.1154 4.47194 13.5998 3.70026 12.9497 3.05025C12.2997 2.40024 11.5281 1.88463 10.6788 1.53284C9.8295 1.18106 8.91925 1 8 1ZM8 13.6C6.51479 13.6 5.09041 13.01 4.0402 11.9598C2.99 10.9096 2.4 9.48521 2.4 8C2.4 6.51479 2.99 5.09041 4.0402 4.0402C5.09041 2.99 6.51479 2.4 8 2.4C9.48521 2.4 10.9096 2.99 11.9598 4.0402C13.01 5.09041 13.6 6.51479 13.6 8C13.6 9.48521 13.01 10.9096 11.9598 11.9598C10.9096 13.01 9.48521 13.6 8 13.6Z"
        fill={props.color || "#4E4E4E"}
      />
    </svg>
  );
};

export const ProcedureIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M4.55319 3.79358C4.48298 3.79358 4.42553 3.85138 4.42553 3.92202V4.69266C4.42553 4.7633 4.48298 4.8211 4.55319 4.8211H10.6809C10.7511 4.8211 10.8085 4.7633 10.8085 4.69266V3.92202C10.8085 3.85138 10.7511 3.79358 10.6809 3.79358H4.55319ZM7.48936 6.1055H4.55319C4.48298 6.1055 4.42553 6.1633 4.42553 6.23394V7.00459C4.42553 7.07523 4.48298 7.13303 4.55319 7.13303H7.48936C7.55957 7.13303 7.61702 7.07523 7.61702 7.00459V6.23394C7.61702 6.1633 7.55957 6.1055 7.48936 6.1055ZM6.7234 13.4587H3.14894V2.15596H12.0851V7.29358C12.0851 7.36422 12.1426 7.42202 12.2128 7.42202H13.1064C13.1766 7.42202 13.234 7.36422 13.234 7.29358V1.51376C13.234 1.22959 13.0059 1 12.7234 1H2.51064C2.22819 1 2 1.22959 2 1.51376V14.1009C2 14.3851 2.22819 14.6147 2.51064 14.6147H6.7234C6.79362 14.6147 6.85106 14.5569 6.85106 14.4862V13.5872C6.85106 13.5165 6.79362 13.4587 6.7234 13.4587ZM13.7447 12.0459H11.4468V11.4583C12.1856 11.2367 12.7234 10.5495 12.7234 9.73394C12.7234 8.74014 11.9239 7.93578 10.9362 7.93578C9.9484 7.93578 9.14894 8.74014 9.14894 9.73394C9.14894 10.5479 9.6867 11.2367 10.4255 11.4583V12.0459H8.12766C7.98723 12.0459 7.87234 12.1615 7.87234 12.3028V14.7431C7.87234 14.8844 7.98723 15 8.12766 15H13.7447C13.8851 15 14 14.8844 14 14.7431V12.3028C14 12.1615 13.8851 12.0459 13.7447 12.0459ZM10.1383 9.73394C10.1383 9.29083 10.4957 8.93119 10.9362 8.93119C11.3766 8.93119 11.734 9.29083 11.734 9.73394C11.734 10.1771 11.3766 10.5367 10.9362 10.5367C10.4957 10.5367 10.1383 10.1771 10.1383 9.73394ZM13.0106 14.0046H8.8617V13.0413H13.0106V14.0046Z"
        fill={props.color}
      />
    </svg>
  );
};

export const ProfileIcon = (props) => {
  return (
    <svg
      width={props.width || "24"}
      height={props.height || "24"}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0011 13.1692C15.0429 13.1692 15.9837 12.7541 16.6671 12.0863C17.3489 11.4169 17.7702 10.4904 17.7702 9.46906C17.7702 8.44627 17.3489 7.52271 16.6671 6.85186C15.9852 6.18251 15.043 5.76888 14.0011 5.76888C12.9592 5.76888 12.0184 6.18402 11.3351 6.85186C10.6533 7.52121 10.2319 8.44623 10.2319 9.46906C10.2319 10.4919 10.6548 11.4169 11.3351 12.0863C12.0169 12.7556 12.9592 13.1692 14.0011 13.1692ZM17.9403 13.3362C16.9337 14.3244 15.5394 14.9381 14.0011 14.9381C12.4628 14.9381 11.07 14.326 10.0619 13.3362C9.05369 12.3465 8.43007 10.9777 8.43007 9.46906C8.43007 7.9589 9.05365 6.59163 10.0619 5.60192C11.07 4.6122 12.4628 4 14.0011 4C15.5394 4 16.9321 4.61216 17.9403 5.60192C18.9485 6.59163 19.5721 7.9589 19.5721 9.46906C19.5721 10.9792 18.9485 12.3465 17.9403 13.3362ZM5.93122 23.7432C5.57882 24.0861 5.01036 24.0846 4.66104 23.7402C4.31171 23.3942 4.31324 22.8362 4.6641 22.4932C5.88219 21.3019 7.33774 20.3423 8.95438 19.688C10.5141 19.0548 12.2179 18.7058 13.9997 18.7058C15.7816 18.7058 17.4869 19.0548 19.045 19.688C20.6615 20.3423 22.117 21.3034 23.3353 22.4932C23.6877 22.8362 23.6877 23.3942 23.3384 23.7402C22.989 24.0861 22.4206 24.0861 22.0682 23.7432C21.0141 22.7128 19.7562 21.8826 18.3619 21.317C17.0212 20.774 15.5488 20.4732 13.9983 20.4732C12.4492 20.4732 10.9738 20.774 9.63464 21.317C8.24036 21.8826 6.98246 22.7128 5.92832 23.7432H5.93122Z"
        fill={props.color || "white"}
      />
    </svg>
  );
};

export const ProfileEditIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.6507 6.54222L1.25978 8.23245C1.2463 8.29424 1.24676 8.35827 1.26114 8.41985C1.27551 8.48144 1.30344 8.53903 1.34287 8.58841C1.38231 8.6378 1.43226 8.67774 1.48908 8.70531C1.5459 8.73288 1.60814 8.74739 1.67127 8.74777C1.70069 8.75074 1.73033 8.75074 1.75974 8.74777L3.45713 8.35613L7.59935 4.21874L5.78191 2.40204L5.78057 2.40071L1.6507 6.54222ZM5.78148 3.43062L2.31299 6.90868L2.07732 7.92769L3.0904 7.69394L6.56954 4.21835L5.78148 3.43062ZM8.62602 3.1943C8.66551 3.15453 8.69679 3.10736 8.71806 3.05547C8.73934 3.00358 8.75019 2.94799 8.75 2.8919C8.74981 2.8358 8.73858 2.78029 8.71695 2.72855C8.69532 2.67681 8.66372 2.62985 8.62396 2.59035L7.41007 1.37421C7.33026 1.29466 7.22226 1.25 7.10969 1.25C6.99711 1.25 6.8891 1.29466 6.8093 1.37421L6.1345 2.05025L7.95118 3.87039L8.62602 3.1943Z"
        fill="#4E4E4E"
      />
    </svg>
  );
};

export const DefaultUserProfileIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ? props.width : "56"}
      height={props.height ? props.height : "56"}
      viewBox="0 0 56 56"
      fill="none"
    >
      <circle cx="28" cy="28" r="28" fill="#F2F2F2" />
      <path
        d="M14 41.6625V35.5127C14 30.5783 18.1787 26.5782 23.3333 26.5782H32.6667C37.8213 26.5782 42 30.5783 42 35.5127V41.6625C38.2444 44.9885 33.3512 47 28 47C22.6488 47 17.7556 44.9885 14 41.6625Z"
        fill="white"
      />
      <path
        d="M36.642 16.5091C36.642 21.091 32.7865 25.3018 28 25.3018C23.2135 25.3018 19.358 21.091 19.358 16.5091C19.358 11.9271 23.2135 8 28 8C32.7865 8 36.642 11.9271 36.642 16.5091Z"
        fill="white"
      />
    </svg>
  );
};

export const DefaultCorporateProfileIcon = (props) => {
  return (
    <svg
      width={props.width || "48"}
      height={props.height || "48"}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="#F1F1F1" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.3684 10C20.4383 10 19.6842 10.7429 19.6842 11.6593V17.0519H15.6842C14.754 17.0519 14 17.7947 14 18.7111V38H19.6842V17.0519H23.4737C24.4038 17.0519 25.1579 17.7947 25.1579 18.7111V38H34V11.6593C34 10.7429 33.246 10 32.3158 10H21.3684Z"
        fill={props.color || "#E5E5E5"}
      />
    </svg>
  );
};

export const JobsIcon = (props) => {
  return (
    <svg
      width={props.width ? props.width : "20"}
      height={props.height ? props.height : "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33366 17.4998C2.87533 17.4998 2.4831 17.3368 2.15699 17.0107C1.83088 16.6846 1.66755 16.2921 1.66699 15.8332V6.6665C1.66699 6.20817 1.83033 5.81595 2.15699 5.48984C2.48366 5.16373 2.87588 5.00039 3.33366 4.99984H6.66699V3.33317C6.66699 2.87484 6.83033 2.48262 7.15699 2.1565C7.48366 1.83039 7.87588 1.66706 8.33366 1.6665H11.667C12.1253 1.6665 12.5178 1.82984 12.8445 2.1565C13.1712 2.48317 13.3342 2.87539 13.3337 3.33317V4.99984H16.667C17.1253 4.99984 17.5178 5.16317 17.8445 5.48984C18.1712 5.8165 18.3342 6.20873 18.3337 6.6665V15.8332C18.3337 16.2915 18.1706 16.684 17.8445 17.0107C17.5184 17.3373 17.1259 17.5004 16.667 17.4998H3.33366ZM3.33366 15.8332H16.667V6.6665H3.33366V15.8332ZM8.33366 4.99984H11.667V3.33317H8.33366V4.99984Z"
        fill={props.color || "white"}
      />
    </svg>
  );
};

export const ExitIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M11.3333 4.66667L10.3933 5.60667L12.1133 7.33333H5.33325V8.66667H12.1133L10.3933 10.3867L11.3333 11.3333L14.6666 8L11.3333 4.66667ZM2.66659 3.33333H7.99992V2H2.66659C1.93325 2 1.33325 2.6 1.33325 3.33333V12.6667C1.33325 13.4 1.93325 14 2.66659 14H7.99992V12.6667H2.66659V3.33333Z"
        fill={props.color || "#404040"}
      />
    </svg>
  );
};
export const ReferIcon = (props) => {
  return (
    <svg
      width={props.width ? props.width : "20"}
      height={props.height ? props.height : "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.54741 10.696C8.12591 10.4326 7.57065 10.5607 7.30721 10.9822C7.04377 11.4037 7.17191 11.959 7.59341 12.2224L8.54741 10.696ZM7.6232 7.75908C7.20169 8.02252 7.07356 8.57777 7.337 8.99928C7.60044 9.42078 8.15569 9.54892 8.5772 9.28548L7.6232 7.75908ZM7.59341 12.2224L11.3071 14.5435L12.2611 13.0171L8.54741 10.696L7.59341 12.2224ZM8.5772 9.28548L12.2613 6.98293L11.3073 5.45653L7.6232 7.75908L8.5772 9.28548ZM14.023 6.58582C13.1315 6.58582 12.4088 5.86311 12.4088 4.97161H10.6088C10.6088 6.85722 12.1374 8.38582 14.023 8.38582V6.58582ZM12.4088 4.97161C12.4088 4.0801 13.1315 3.3574 14.023 3.3574V1.5574C12.1374 1.5574 10.6088 3.08599 10.6088 4.97161H12.4088ZM14.023 3.3574C14.9145 3.3574 15.6372 4.0801 15.6372 4.97161H17.4372C17.4372 3.08599 15.9086 1.5574 14.023 1.5574V3.3574ZM15.6372 4.97161C15.6372 5.86311 14.9145 6.58582 14.023 6.58582V8.38582C15.9086 8.38582 17.4372 6.85722 17.4372 4.97161H15.6372ZM14.023 16.6427C13.1315 16.6427 12.4088 15.92 12.4088 15.0285H10.6088C10.6088 16.9141 12.1374 18.4427 14.023 18.4427V16.6427ZM12.4088 15.0285C12.4088 14.137 13.1315 13.4143 14.023 13.4143V11.6143C12.1374 11.6143 10.6088 13.1429 10.6088 15.0285H12.4088ZM14.023 13.4143C14.9145 13.4143 15.6372 14.137 15.6372 15.0285H17.4372C17.4372 13.1429 15.9086 11.6143 14.023 11.6143V13.4143ZM15.6372 15.0285C15.6372 15.92 14.9145 16.6427 14.023 16.6427V18.4427C15.9086 18.4427 17.4372 16.9141 17.4372 15.0285H15.6372ZM5.9771 11.6141C5.0856 11.6141 4.36289 10.8914 4.36289 9.99993H2.56289C2.56289 11.8855 4.09148 13.4141 5.9771 13.4141V11.6141ZM4.36289 9.99993C4.36289 9.10842 5.0856 8.38572 5.9771 8.38572V6.58572C4.09148 6.58572 2.56289 8.11431 2.56289 9.99993H4.36289ZM5.9771 8.38572C6.8686 8.38572 7.59131 9.10842 7.59131 9.99993H9.39131C9.39131 8.11431 7.86272 6.58572 5.9771 6.58572V8.38572ZM7.59131 9.99993C7.59131 10.8914 6.8686 11.6141 5.9771 11.6141V13.4141C7.86272 13.4141 9.39131 11.8855 9.39131 9.99993H7.59131Z"
        fill={props.color || "#404040"}
      />
    </svg>
  );
};

export const ArrowIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M6.20668 4.47319C6.14488 4.53486 6.09585 4.60812 6.06239 4.68877C6.02894 4.76942 6.01172 4.85587 6.01172 4.94319C6.01172 5.0305 6.02894 5.11695 6.06239 5.1976C6.09585 5.27825 6.14488 5.35151 6.20668 5.41319L8.79335 7.99985L6.20668 10.5865C6.08203 10.7112 6.012 10.8802 6.012 11.0565C6.012 11.2328 6.08203 11.4019 6.20668 11.5265C6.33133 11.6512 6.5004 11.7212 6.67668 11.7212C6.85297 11.7212 7.02203 11.6512 7.14668 11.5265L10.2067 8.46652C10.2685 8.40484 10.3175 8.33158 10.351 8.25093C10.3844 8.17029 10.4016 8.08383 10.4016 7.99652C10.4016 7.90921 10.3844 7.82275 10.351 7.7421C10.3175 7.66145 10.2685 7.58819 10.2067 7.52652L7.14668 4.46652C6.89335 4.21319 6.46668 4.21319 6.20668 4.47319Z"
        fill={props.color || "#404040"}
      />
    </svg>
  );
};

export const BackArrowIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M3.54368 7.49951H13.9777C14.1161 7.49951 14.2488 7.55218 14.3466 7.64594C14.4445 7.7397 14.4994 7.86686 14.4994 7.99945C14.4994 8.13204 14.4445 8.2592 14.3466 8.35296C14.2488 8.44671 14.1161 8.49939 13.9777 8.49939H3.54368C3.40531 8.49939 3.27261 8.44671 3.17478 8.35296C3.07694 8.2592 3.02197 8.13204 3.02197 7.99945C3.02197 7.86686 3.07694 7.7397 3.17478 7.64594C3.27261 7.55218 3.40531 7.49951 3.54368 7.49951Z"
        fill={props.color || "#404040"}
      />
      <path
        d="M3.75959 7.99951L8.0866 12.145C8.18456 12.2389 8.23959 12.3662 8.23959 12.4989C8.23959 12.6317 8.18456 12.759 8.0866 12.8529C7.98863 12.9468 7.85577 12.9995 7.71723 12.9995C7.57869 12.9995 7.44583 12.9468 7.34786 12.8529L2.65254 8.35347C2.60395 8.30703 2.56541 8.25186 2.53911 8.19112C2.51281 8.13038 2.49927 8.06527 2.49927 7.99951C2.49927 7.93375 2.51281 7.86864 2.53911 7.8079C2.56541 7.74717 2.60395 7.692 2.65254 7.64556L7.34786 3.14612C7.44583 3.05225 7.57869 2.99951 7.71723 2.99951C7.85577 2.99951 7.98863 3.05225 8.0866 3.14612C8.18456 3.24 8.23959 3.36732 8.23959 3.50008C8.23959 3.63284 8.18456 3.76016 8.0866 3.85404L3.75959 7.99951Z"
        fill={props.color || "#404040"}
      />
    </svg>
  );
};

export const ClockIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M8 15.5C6.61553 15.5 5.26216 15.0895 4.11101 14.3203C2.95987 13.5511 2.06266 12.4579 1.53285 11.1788C1.00303 9.8997 0.86441 8.49224 1.13451 7.13437C1.4046 5.7765 2.07129 4.52922 3.05026 3.55026C4.02922 2.57129 5.2765 1.9046 6.63437 1.63451C7.99224 1.36441 9.3997 1.50303 10.6788 2.03285C11.9579 2.56266 13.0511 3.45987 13.8203 4.61101C14.5895 5.76216 15 7.11553 15 8.5C15 10.3565 14.2625 12.137 12.9497 13.4497C11.637 14.7625 9.85652 15.5 8 15.5ZM8 2.5C6.81332 2.5 5.65328 2.8519 4.66658 3.51119C3.67989 4.17047 2.91085 5.10755 2.45673 6.2039C2.0026 7.30026 1.88378 8.50666 2.11529 9.67054C2.3468 10.8344 2.91825 11.9035 3.75736 12.7426C4.59648 13.5818 5.66558 14.1532 6.82946 14.3847C7.99335 14.6162 9.19975 14.4974 10.2961 14.0433C11.3925 13.5892 12.3295 12.8201 12.9888 11.8334C13.6481 10.8467 14 9.68669 14 8.5C14 6.9087 13.3679 5.38258 12.2426 4.25736C11.1174 3.13214 9.5913 2.5 8 2.5Z"
        fill={props.color || "#404040"}
      />
      <path
        d="M10.295 11.5L7.5 8.705V4H8.5V8.29L11 10.795L10.295 11.5Z"
        fill={props.color || "#404040"}
      />
    </svg>
  );
};

export const AddIcon = (props) => {
  return (
    <svg
      width={props.width ? props.width : "16"}
      height={props.height ? props.height : "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 1C9 0.447715 8.55229 0 8 0C7.44772 0 7 0.447715 7 1V5.66667C7 6.40305 6.40305 7 5.66667 7H1C0.447715 7 0 7.44772 0 8C0 8.55229 0.447715 9 1 9H5.66667C6.40305 9 7 9.59695 7 10.3333V15C7 15.5523 7.44772 16 8 16C8.55229 16 9 15.5523 9 15V10.3333C9 9.59695 9.59695 9 10.3333 9H15C15.5523 9 16 8.55229 16 8C16 7.44772 15.5523 7 15 7H10.3333C9.59695 7 9 6.40305 9 5.66667V1Z"
        fill={props.color || "#404040"}
      />
    </svg>
  );
};

export const PlayIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.6" cx="16" cy="16" r="15.5" stroke="#0249D6" />
      <path
        d="M13.155 21.5001C12.9631 21.4997 12.7747 21.4494 12.6081 21.3541C12.2331 21.1416 12 20.7291 12 20.2813V11.2188C12 10.7697 12.2331 10.3585 12.6081 10.146C12.7786 10.048 12.9723 9.99761 13.169 10.0001C13.3656 10.0026 13.558 10.0578 13.7259 10.1601L21.4712 14.7963C21.6327 14.8975 21.7657 15.0381 21.858 15.2048C21.9502 15.3715 21.9986 15.5589 21.9986 15.7494C21.9986 15.94 21.9502 16.1274 21.858 16.2941C21.7657 16.4608 21.6327 16.6013 21.4712 16.7026L13.7247 21.3401C13.5528 21.444 13.3559 21.4993 13.155 21.5001Z"
        fill="#0249D6"
      />
    </svg>
  );
};

export const PauseIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.6" cx="16" cy="16" r="15.5" stroke="#0249D6" />
      <path
        d="M12 12.6429C12 12.2878 12.2878 12 12.6429 12V12C12.9979 12 13.2857 12.2878 13.2857 12.6429V20.3571C13.2857 20.7122 12.9979 21 12.6429 21V21C12.2878 21 12 20.7122 12 20.3571V12.6429ZM18.4286 12.6429C18.4286 12.2878 18.7164 12 19.0714 12V12C19.4265 12 19.7143 12.2878 19.7143 12.6429V20.3571C19.7143 20.7122 19.4265 21 19.0714 21V21C18.7164 21 18.4286 20.7122 18.4286 20.3571V12.6429Z"
        fill="#0249D6"
      />
    </svg>
  );
};

export const MicIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.6" cx="16" cy="16" r="15.5" stroke="#0249D6" />
      <path
        d="M18.5 15.4615C18.5 16.1756 18.2366 16.8604 17.7678 17.3653C17.2989 17.8702 16.663 18.1538 16 18.1538C15.337 18.1538 14.7011 17.8702 14.2322 17.3653C13.7634 16.8604 13.5 16.1756 13.5 15.4615V11.6923C13.5 10.9783 13.7634 10.2935 14.2322 9.78856C14.7011 9.28365 15.337 9 16 9C16.663 9 17.2989 9.28365 17.7678 9.78856C18.2366 10.2935 18.5 10.9783 18.5 11.6923V15.4615Z"
        stroke="#0249D6"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 16C21.0013 16.6368 20.8858 17.2676 20.6601 17.8562C20.4345 18.4448 20.103 18.9796 19.6849 19.4299C19.2668 19.8802 18.7702 20.2371 18.2236 20.4802C17.6771 20.7232 17.0913 20.8476 16.5 20.8462H15.5C14.9087 20.8476 14.3229 20.7232 13.7764 20.4802C13.2298 20.2371 12.7332 19.8802 12.3151 19.4299C11.897 18.9796 11.5655 18.4448 11.3399 17.8562C11.1142 17.2676 10.9987 16.6368 11 16M16 20.8462V23"
        stroke="#0249D6"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const StopIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.6" cx="16" cy="16" r="15.5" stroke="#0249D6" />
      <rect x="10" y="10" width="12" height="12" rx="2" fill="#0249D6" />
    </svg>
  );
};

export const CalendarIcon = (props) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6875 14H1.3125C0.58625 14 0 13.4137 0 12.6875V2.1875C0 1.46125 0.58625 0.875 1.3125 0.875H12.6875C13.4137 0.875 14 1.46125 14 2.1875V12.6875C14 13.4137 13.4137 14 12.6875 14ZM1.3125 1.75C1.0675 1.75 0.875 1.9425 0.875 2.1875V12.6875C0.875 12.9325 1.0675 13.125 1.3125 13.125H12.6875C12.9325 13.125 13.125 12.9325 13.125 12.6875V2.1875C13.125 1.9425 12.9325 1.75 12.6875 1.75H1.3125Z"
        fill="#404040"
      />
      <path
        d="M3.9375 3.5C3.6925 3.5 3.5 3.3075 3.5 3.0625V0.4375C3.5 0.1925 3.6925 0 3.9375 0C4.1825 0 4.375 0.1925 4.375 0.4375V3.0625C4.375 3.3075 4.1825 3.5 3.9375 3.5ZM10.0625 3.5C9.8175 3.5 9.625 3.3075 9.625 3.0625V0.4375C9.625 0.1925 9.8175 0 10.0625 0C10.3075 0 10.5 0.1925 10.5 0.4375V3.0625C10.5 3.3075 10.3075 3.5 10.0625 3.5ZM13.5625 5.25H0.4375C0.1925 5.25 0 5.0575 0 4.8125C0 4.5675 0.1925 4.375 0.4375 4.375H13.5625C13.8075 4.375 14 4.5675 14 4.8125C14 5.0575 13.8075 5.25 13.5625 5.25Z"
        fill="#404040"
      />
    </svg>
  );
};

export const ProcedureTitleIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.354 5.104C7.44789 5.01011 7.50063 4.88278 7.50063 4.75C7.50063 4.61722 7.44789 4.48989 7.354 4.396C7.26011 4.30211 7.13278 4.24937 7 4.24937C6.86722 4.24937 6.73989 4.30211 6.646 4.396L5.234 5.808L4.837 5.446C4.73836 5.36169 4.6108 5.31903 4.48129 5.32703C4.35177 5.33504 4.23044 5.39308 4.14293 5.4889C4.05543 5.58472 4.0086 5.7108 4.01234 5.84051C4.01609 5.97022 4.07011 6.09339 4.163 6.184L4.913 6.869C5.00803 6.95552 5.13272 7.00213 5.2612 6.99915C5.38968 6.99617 5.51208 6.94383 5.603 6.853L7.353 5.103L7.354 5.104ZM7.354 9.396C7.40056 9.44245 7.43751 9.49762 7.46271 9.55837C7.48792 9.61911 7.50089 9.68423 7.50089 9.75C7.50089 9.81577 7.48792 9.88089 7.46271 9.94163C7.43751 10.0024 7.40056 10.0576 7.354 10.104L5.604 11.854C5.51291 11.945 5.39023 11.9973 5.26151 12.0001C5.13279 12.0029 5.00796 11.9559 4.913 11.869L4.163 11.184C4.07011 11.0934 4.01609 10.9702 4.01234 10.8405C4.0086 10.7108 4.05543 10.5847 4.14293 10.4889C4.23044 10.3931 4.35177 10.335 4.48129 10.327C4.6108 10.319 4.73836 10.3617 4.837 10.446L5.234 10.809L6.646 9.396C6.69245 9.34944 6.74762 9.31249 6.80837 9.28729C6.86911 9.26208 6.93423 9.24911 7 9.24911C7.06577 9.24911 7.13089 9.26208 7.19163 9.28729C7.25238 9.31249 7.30755 9.34944 7.354 9.396ZM9 10C8.86739 10 8.74021 10.0527 8.64645 10.1464C8.55268 10.2402 8.5 10.3674 8.5 10.5C8.5 10.6326 8.55268 10.7598 8.64645 10.8536C8.74021 10.9473 8.86739 11 9 11H11.5C11.6326 11 11.7598 10.9473 11.8536 10.8536C11.9473 10.7598 12 10.6326 12 10.5C12 10.3674 11.9473 10.2402 11.8536 10.1464C11.7598 10.0527 11.6326 10 11.5 10H9ZM8.5 5.5C8.5 5.36739 8.55268 5.24021 8.64645 5.14645C8.74021 5.05268 8.86739 5 9 5H11.5C11.6326 5 11.7598 5.05268 11.8536 5.14645C11.9473 5.24021 12 5.36739 12 5.5C12 5.63261 11.9473 5.75979 11.8536 5.85355C11.7598 5.94732 11.6326 6 11.5 6H9C8.86739 6 8.74021 5.94732 8.64645 5.85355C8.55268 5.75979 8.5 5.63261 8.5 5.5ZM4 1C3.20435 1 2.44129 1.31607 1.87868 1.87868C1.31607 2.44129 1 3.20435 1 4V12C1 12.7956 1.31607 13.5587 1.87868 14.1213C2.44129 14.6839 3.20435 15 4 15H12C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12V4C15 3.20435 14.6839 2.44129 14.1213 1.87868C13.5587 1.31607 12.7956 1 12 1H4ZM2 4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H12C12.5304 2 13.0391 2.21071 13.4142 2.58579C13.7893 2.96086 14 3.46957 14 4V12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14H4C3.46957 14 2.96086 13.7893 2.58579 13.4142C2.21071 13.0391 2 12.5304 2 12V4Z"
        fill="#404040"
      />
    </svg>
  );
};

export const LocationIcon = (props) => {
  return (
    <svg
      width={props.width || "12"}
      height={props.height || "12"}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.83099 11.2984C5.86508 11.3635 5.93141 11.4008 6.00007 11.401C6.06873 11.4008 6.13505 11.3635 6.16915 11.2984C6.70837 10.2672 7.42259 9.59018 8.09205 8.95562C9.1976 7.90844 10.1884 6.96913 10.1884 4.78692C10.1884 3.6311 9.71912 2.58333 8.96164 1.82585C8.20372 1.06787 7.15648 0.599121 6.00007 0.599121C4.84365 0.599121 3.79641 1.06787 3.0385 1.82585C2.28102 2.58333 1.81177 3.6311 1.81177 4.78692C1.81177 6.96913 2.80253 7.90844 3.90808 8.95562C4.57755 9.59018 5.29177 10.2672 5.83099 11.2984ZM6.00007 2.13755C5.26849 2.13755 4.60625 2.43376 4.12653 2.91348C3.64731 3.3927 3.3506 4.05544 3.3506 4.78702C3.3506 5.5186 3.64681 6.18083 4.12653 6.66055C4.60579 7.13977 5.26852 7.43645 6.00007 7.43648C6.73162 7.43645 7.39435 7.13977 7.8736 6.66055C8.35332 6.18083 8.64953 5.5186 8.64953 4.78702C8.64953 4.05544 8.35282 3.3927 7.8736 2.91348C7.39388 2.43376 6.73165 2.13755 6.00007 2.13755Z"
        fill={props.color || "#404040"}
      />
    </svg>
  );
};

export const TickIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5301 4.19645C13.7897 4.45609 13.7897 4.87704 13.5301 5.13667L6.70727 11.9595C6.31674 12.35 5.68358 12.35 5.29306 11.9595L2.80378 9.47018C2.54405 9.21045 2.54405 8.78934 2.80378 8.52961C3.06329 8.2701 3.48396 8.26984 3.74378 8.52903L5.29339 10.0749C5.68392 10.4644 6.31616 10.4642 6.7064 10.0743L12.5901 4.19623C12.8497 3.9368 13.2705 3.9369 13.5301 4.19645Z"
        fill={props.color ? props.color : "#404040"}
      />
    </svg>
  );
};

export const ImageFallbackIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g opacity="0.6" clipPath="url(#clip0_1268_3459)">
        <path
          d="M14.224 1.77832H1.77951C1.54377 1.77832 1.31767 1.87197 1.15097 2.03867C0.984275 2.20537 0.890625 2.43146 0.890625 2.66721V13.3339C0.890625 13.5696 0.984275 13.7957 1.15097 13.9624C1.31767 14.1291 1.54377 14.2228 1.77951 14.2228H14.224C14.4597 14.2228 14.6858 14.1291 14.8525 13.9624C15.0192 13.7957 15.1128 13.5696 15.1128 13.3339V2.66721C15.1128 2.43146 15.0192 2.20537 14.8525 2.03867C14.6858 1.87197 14.4597 1.77832 14.224 1.77832ZM1.77951 13.3339V2.66721H14.224V13.3339H1.77951Z"
          fill="#404040"
        />
        <path
          d="M3.96615 6.22233C4.22985 6.22233 4.48764 6.14413 4.70691 5.99762C4.92617 5.85112 5.09707 5.64288 5.19799 5.39924C5.2989 5.15561 5.32531 4.88752 5.27386 4.62888C5.22241 4.37024 5.09542 4.13266 4.90895 3.94619C4.72248 3.75972 4.48491 3.63273 4.22627 3.58128C3.96762 3.52984 3.69954 3.55624 3.4559 3.65716C3.21227 3.75808 3.00403 3.92897 2.85752 4.14824C2.71101 4.3675 2.63281 4.62529 2.63281 4.889C2.63281 5.24262 2.77329 5.58176 3.02334 5.83181C3.27339 6.08186 3.61252 6.22233 3.96615 6.22233ZM3.96615 4.17789C4.10698 4.17701 4.2449 4.21796 4.36242 4.29556C4.47995 4.37317 4.57178 4.48392 4.62629 4.61377C4.68079 4.74363 4.69551 4.88675 4.66858 5.02498C4.64164 5.16322 4.57427 5.29034 4.475 5.39024C4.37572 5.49013 4.24903 5.5583 4.11096 5.5861C3.9729 5.6139 3.82969 5.60008 3.6995 5.54639C3.5693 5.4927 3.45797 5.40156 3.37964 5.28453C3.3013 5.16749 3.25948 5.02983 3.25948 4.889C3.26064 4.70194 3.33547 4.52287 3.46775 4.3906C3.60002 4.25832 3.77909 4.1835 3.96615 4.18233V4.17789Z"
          fill="#404040"
        />
        <path
          d="M10.1261 6.83139L7.72615 9.23139L5.94837 7.45361C5.8651 7.37083 5.75245 7.32437 5.63503 7.32437C5.51762 7.32437 5.40497 7.37083 5.3217 7.45361L2.63281 10.1781V11.4358L5.65059 8.41806L7.11281 9.85806L5.44615 11.5247H6.66837L10.4239 7.76917L13.335 10.6669V9.41361L10.7528 6.83139C10.6695 6.74861 10.5569 6.70215 10.4395 6.70215C10.3221 6.70215 10.2094 6.74861 10.1261 6.83139Z"
          fill="#404040"
        />
      </g>
      <defs>
        <clipPath id="clip0_1268_3459">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ErrorBoundaryFallBack = () => {
  return (
    <svg
      width="147"
      height="156"
      viewBox="0 0 147 156"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.56294 132.768C3.97014 130.648 5.47455 128.904 7.5123 128.191L21.646 123.243C25.0618 122.048 28.7572 124.093 29.5583 127.622L34.0771 147.529C35.0102 151.639 31.5658 155.424 27.3857 154.88L6.3846 152.15C2.92267 151.7 0.555873 148.425 1.21431 144.997L3.56294 132.768Z"
        fill="#F1F1F1"
      />
      <path
        d="M128.913 12.6104C128.491 8.16241 132.863 4.80178 137.052 6.35423L139.977 7.43804C141.626 8.04898 142.928 9.3459 143.546 10.9922L144.406 13.2843C145.748 16.8631 143.483 20.7759 139.711 21.3936L136.3 21.9522C132.838 22.5191 129.619 20.0372 129.287 16.5449L128.913 12.6104Z"
        fill="#F1F1F1"
      />
      <path
        d="M128.581 117.383C128.313 114.445 131.226 112.249 133.977 113.314C135.052 113.731 135.894 114.594 136.284 115.679L136.383 115.955C137.226 118.305 135.743 120.846 133.282 121.267C130.974 121.662 128.819 120.006 128.607 117.674L128.581 117.383Z"
        fill="#F1F1F1"
      />
      <path
        d="M18.8427 13.6181C18.4421 10.4723 21.3737 7.9331 24.4301 8.77845L27.072 9.50915C28.133 9.80259 29.0203 10.5311 29.5146 11.5147C30.7252 13.9236 29.1822 16.8044 26.5061 17.1315L23.7853 17.4641C21.3602 17.7605 19.1513 16.0417 18.8427 13.6181Z"
        fill="#F1F1F1"
      />
      <path
        d="M37.8677 31.6791C37.0845 27.6202 40.6294 24.0445 44.6949 24.7926L107.114 36.279C110.262 36.8582 112.365 39.8514 111.844 43.0089L106.384 76.0969C106.304 76.5809 106.282 77.0726 106.317 77.5619L108.123 102.726C108.362 106.054 105.781 108.913 102.446 109.014L49.7149 110.62C46.4039 110.721 43.6651 108.065 43.6651 104.752V62.3188C43.6651 61.9214 43.6272 61.5248 43.5519 61.1346L37.8677 31.6791Z"
        fill="#F1F1F1"
        stroke="#959595"
        strokeWidth="0.378774"
      />
      <circle cx="62" cy="65" r="8" fill="#E5E5E5" />
      <circle cx="67.5" cy="70.5" r="2.5" fill="#959595" />
      <circle cx="87" cy="65" r="8" fill="#E5E5E5" />
      <circle cx="81.5" cy="70.5" r="2.5" fill="#959595" />
      <path
        d="M58 95C62.9998 91.2645 76.81 80.8642 91 89.0827"
        stroke="#959595"
        strokeWidth="0.757547"
      />
      <path
        d="M68 35.3333L71.6 29L74 29.6667L69.5 35.3333L73.4 41L70.4 50L72.8 41L68 35.3333Z"
        fill="#959595"
      />
    </svg>
  );
};

export const FilterIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 3H15M1 8H10.3333M1 13H4.73333"
        stroke={props.color || "#404040"}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ResetIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3811 11.6828C10.6662 12.3394 9.77549 12.7736 8.8178 12.9325C7.86011 13.0915 6.87686 12.9682 5.98808 12.5778C5.09931 12.1873 4.34347 11.5467 3.81285 10.734C3.28223 9.92124 2.99978 8.97166 3 8.00115H3.83319C3.83313 8.84002 4.08647 9.65935 4.56003 10.3519C5.03358 11.0444 5.70528 11.5778 6.48718 11.8822C7.26907 12.1867 8.1247 12.248 8.94204 12.0582C9.75937 11.8683 10.5003 11.4361 11.0678 10.8182H9.85719C9.7467 10.8182 9.64074 10.7743 9.56261 10.6962C9.48448 10.6181 9.44059 10.5122 9.44059 10.4017C9.44059 10.2913 9.48448 10.1853 9.56261 10.1072C9.64074 10.0291 9.7467 9.98525 9.85719 9.98525H11.7977C11.9082 9.98525 12.0142 10.0291 12.0923 10.1072C12.1704 10.1853 12.2143 10.2913 12.2143 10.4017V12.34C12.2143 12.4505 12.1704 12.5564 12.0923 12.6345C12.0142 12.7126 11.9082 12.7565 11.7977 12.7565C11.6872 12.7565 11.5812 12.7126 11.5031 12.6345C11.425 12.5564 11.3811 12.4505 11.3811 12.34V11.682V11.6828ZM4.93051 5.18493H6.14114C6.25163 5.18493 6.35759 5.22881 6.43572 5.30691C6.51385 5.38502 6.55774 5.49095 6.55774 5.60141C6.55774 5.71186 6.51385 5.8178 6.43572 5.8959C6.35759 5.974 6.25163 6.01788 6.14114 6.01788H4.1998C4.08931 6.01788 3.98335 5.974 3.90522 5.8959C3.82709 5.8178 3.7832 5.71186 3.7832 5.60141V3.66145C3.7832 3.551 3.82709 3.44507 3.90522 3.36696C3.98335 3.28886 4.08931 3.24498 4.1998 3.24498C4.31029 3.24498 4.41625 3.28886 4.49438 3.36696C4.57251 3.44507 4.6164 3.551 4.6164 3.66145V4.31949C5.33124 3.66212 6.22215 3.22717 7.18025 3.06779C8.13836 2.90841 9.12216 3.0315 10.0114 3.42202C10.9007 3.81254 11.6569 4.45357 12.1876 5.26678C12.7184 6.07999 13.0007 7.03015 13 8.00115H12.1668C12.1669 7.16217 11.9135 6.34273 11.4398 5.65015C10.9662 4.95758 10.2943 4.42417 9.51228 4.11978C8.73025 3.81539 7.87448 3.75422 7.05708 3.94428C6.23968 4.13434 5.49875 4.56677 4.93134 5.18493H4.93051Z"
        stroke={props.color || "#404040"}
      />
    </svg>
  );
};

export const SearchIcon = (props) => {
  return (
    <svg
      width={props.width || "18"}
      height={props.height || "18"}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.54439 1C6.25003 1 4.98474 1.38389 3.90852 2.10313C2.8323 2.82237 1.99349 3.84465 1.49816 5.0407C1.00284 6.23675 0.873235 7.55285 1.12575 8.82257C1.37827 10.0923 2.00156 11.2586 2.91681 12.174C3.83206 13.0894 4.99816 13.7128 6.26764 13.9654C7.53713 14.218 8.85299 14.0884 10.0488 13.5929C11.2447 13.0975 12.2667 12.2585 12.9859 11.1821C13.705 10.1057 14.0888 8.84019 14.0888 7.54559C14.0887 5.80963 13.3991 4.14479 12.1719 2.91728C10.9446 1.68977 9.28004 1.00011 7.54439 1Z"
        stroke={props.color || "#404040"}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M12.4297 12.4288L17.0002 17.0002"
        stroke={props.color || "#404040"}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const TickIconWithCircle = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M11.5145 5.31536C11.6887 5.48961 11.6887 5.77213 11.5145 5.94638L6.8144 10.6464C6.61914 10.8417 6.30256 10.8417 6.1073 10.6464L4.31563 8.85478C4.14131 8.68046 4.14131 8.39784 4.31563 8.22352C4.4898 8.04935 4.77212 8.04918 4.9465 8.22313L6.10746 9.38126C6.30273 9.57605 6.61885 9.57593 6.81397 9.38099L10.8836 5.31521C11.0579 5.1411 11.3403 5.14117 11.5145 5.31536Z"
        fill="#4362EA"
      />
      <circle cx="8" cy="8" r="6.5" stroke="#4362EA" />
    </svg>
  );
};

export const LanguageIcon = (props) => {
  return (
    <svg
      width={props.width || "24"}
      height={props.height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1388 17.0011L18.5898 17.0131L19.9338 20.3711C20.1378 20.8841 20.7208 21.1331 21.2328 20.9281C21.7458 20.7241 21.9948 20.1411 21.7898 19.6291L17.7898 9.62912C17.6388 9.24912 17.2708 9.00012 16.8618 9.00012C16.4528 9.00012 16.0848 9.24912 15.9338 9.62912L11.9338 19.6291C11.7288 20.1411 11.9778 20.7241 12.4908 20.9281C13.0028 21.1331 13.5858 20.8841 13.7898 20.3711L15.1388 17.0011ZM15.9378 15.0041L17.7888 15.0101L16.8618 12.6931L15.9378 15.0041ZM9.59572 7.00012C9.09572 8.10312 8.46572 9.25012 7.66272 10.2461C7.33972 9.85512 7.04472 9.44113 6.77472 9.01813C6.47772 8.55213 5.85972 8.41613 5.39372 8.71213C4.92872 9.00913 4.79171 9.62811 5.08871 10.0931C5.43671 10.6391 5.82072 11.1671 6.24472 11.6631C5.34272 12.3681 4.28072 12.8651 3.02672 13.0061C2.47772 13.0681 2.08271 13.5641 2.14471 14.1121C2.20671 14.6611 2.70271 15.0561 3.25071 14.9941C4.98171 14.7981 6.43471 14.0681 7.64871 13.0481C8.57871 13.8111 9.64872 14.4091 10.8737 14.7461C11.4057 14.8921 11.9567 14.5791 12.1027 14.0471C12.2497 13.5151 11.9357 12.9641 11.4037 12.8171C10.5217 12.5751 9.74471 12.1551 9.06071 11.6221C10.4117 10.0051 11.3717 8.06211 12.0307 6.36111C12.2297 5.84611 11.9737 5.26711 11.4587 5.06711C11.3537 5.02711 11.2457 5.00513 11.1387 5.00113L8.68672 5.00012V4.00012C8.68672 3.44812 8.23872 3.00012 7.68672 3.00012C7.13472 3.00012 6.68672 3.44812 6.68672 4.00012V5.00012H3.13872C2.58672 5.00012 2.13872 5.44812 2.13872 6.00012C2.13872 6.55212 2.58672 7.00012 3.13872 7.00012H9.59572Z"
        fill={props.color || "white"}
      />
    </svg>
  );
};

export const AttachmentIcon = (props) => {
  return (
    <svg
      width={props.width ? props.width : "12"}
      height={props.height ? props.height : "12"}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.59088 8.55077C5.59088 8.67277 5.63742 8.78702 5.72311 8.8727C5.80914 8.95874 5.92304 9.00564 6.04504 9.00563C6.23933 9.00457 6.39907 8.84483 6.40048 8.6502L6.4142 2.42128C6.41455 2.10991 6.29431 1.8176 6.07498 1.59828C5.85531 1.3786 5.56299 1.25835 5.25163 1.25871C4.49175 1.26048 3.87078 1.88075 3.86943 2.64163L3.85679 8.44917C3.85573 9.06236 4.09304 9.63888 4.52539 10.0712C4.95775 10.5036 5.53387 10.7412 6.14745 10.7398C7.24091 10.7374 8.13265 9.84563 8.13545 8.75184L8.14321 5.12483L9.06741 5.12659L9.05965 8.7536C9.05789 9.55439 8.73102 10.2818 8.20421 10.8086C7.67706 11.3358 6.94995 11.663 6.1492 11.6641C5.28812 11.6662 4.47921 11.3326 3.8717 10.7251C3.26419 10.1176 2.93054 9.3086 2.93238 8.44794L2.94466 2.64004C2.94748 1.37133 3.98168 0.337835 5.24968 0.334306C5.80857 0.33324 6.33432 0.550102 6.72888 0.944658C7.12345 1.33923 7.33996 1.86462 7.33887 2.42349L7.32479 8.65205C7.32338 9.35586 6.74931 9.92781 6.04694 9.92989C5.67845 9.93095 5.33078 9.78779 5.0695 9.52651C4.80857 9.26558 4.66505 8.91825 4.66611 8.54907L4.67559 4.26518L5.59979 4.26694L5.59067 8.55119L5.59088 8.55077Z"
        fill={props.color ? props.color : "#404040"}
      />
    </svg>
  );
};

export const UndoIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill={props.color || "#959595"}
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z" />
    </svg>
  );
};
export const TextIcon = (props) => {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8155 0L14 3.75221H13.5325C13.4423 3.09145 13.3193 2.61947 13.1634 2.33628C12.9092 1.88004 12.5688 1.54572 12.1424 1.33333C11.7241 1.11308 11.1705 1.00295 10.4815 1.00295H8.13181V13.2271C8.13181 14.2104 8.24253 14.824 8.46397 15.0678C8.77563 15.3982 9.25542 15.5634 9.90334 15.5634H10.4815V16H3.40773V15.5634H3.99824C4.70357 15.5634 5.20387 15.3589 5.49912 14.9499C5.67955 14.6981 5.76977 14.1239 5.76977 13.2271V1.00295H3.7645C2.98535 1.00295 2.43175 1.05801 2.10369 1.16814C1.67721 1.3176 1.31224 1.60472 1.00879 2.0295C0.705331 2.45428 0.524897 3.02852 0.467487 3.75221H0L0.196837 0H13.8155Z"
        fill={props.color || "#959595"}
      />
    </svg>
  );
};

export const BrushIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "8"}
      viewBox={`0 0 ${props.width || "16"} ${props.height || "8"}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 4C2.05376 1.73613 4.97419 -1.43329 8.22581 4C11.4774 9.43329 14.0968 6.26387 15 4"
        stroke="#959595"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const PdfFileIcon = (props) => {
  return (
    <svg
      width={props.width || "32"}
      height={props.height || "32"}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.9381 15.9339C21.6345 16.0255 21.1887 16.0358 20.7108 15.965C20.1979 15.889 19.6747 15.7289 19.1604 15.4929C20.0775 15.3566 20.7889 15.3986 21.3974 15.6188C21.5415 15.671 21.7783 15.8104 21.9381 15.9339ZM16.8217 15.0749C16.7844 15.0852 16.7476 15.095 16.711 15.1054C16.4643 15.174 16.2242 15.2409 15.9928 15.3004L15.6809 15.3812C15.0533 15.5434 14.4117 15.7091 13.778 15.9064C14.0188 15.3132 14.2426 14.7136 14.4617 14.1272C14.6239 13.6932 14.7895 13.2499 14.9608 12.8122C15.0477 12.9588 15.1384 13.1055 15.2328 13.2525C15.6627 13.9212 16.2032 14.5396 16.8217 15.0749ZM15.2254 8.38637C15.2661 9.11824 15.1114 9.82232 14.8846 10.4978C14.6052 9.66257 14.475 8.74028 14.8243 7.99568C14.9139 7.80482 14.9873 7.70278 15.0349 7.64953C15.1084 7.76544 15.2051 8.02475 15.2254 8.38637ZM11.9492 17.6575C11.7922 17.9443 11.632 18.2127 11.4678 18.4663C11.0714 19.0763 10.4233 19.7294 10.0903 19.7294C10.0575 19.7294 10.0179 19.724 9.95993 19.6615C9.92264 19.6215 9.91666 19.5929 9.91847 19.5538C9.9297 19.3296 10.2206 18.9302 10.6421 18.5599C11.0247 18.2239 11.4571 17.9252 11.9492 17.6575ZM22.9984 15.9656C22.9475 15.2186 21.7162 14.7394 21.704 14.7349C21.2281 14.5626 20.7109 14.4789 20.1233 14.4789C19.4942 14.4789 18.8159 14.5718 17.9448 14.7797C17.1698 14.2185 16.5002 13.5161 16 12.7384C15.7791 12.3948 15.5805 12.0518 15.4074 11.7168C15.83 10.6848 16.2106 9.57522 16.1414 8.33248C16.0857 7.33601 15.6457 6.66667 15.0473 6.66667C14.6369 6.66667 14.2835 6.97713 13.9961 7.5903C13.4835 8.6829 13.6183 10.0809 14.3964 11.7492C14.1162 12.4214 13.8558 13.1184 13.6037 13.7931C13.2901 14.632 12.967 15.4975 12.6029 16.3209C11.5816 16.7336 10.7426 17.2341 10.0433 17.8485C9.58526 18.2503 9.03304 18.8646 9.00152 19.5058C8.98614 19.8078 9.08753 20.0847 9.29357 20.3067C9.51246 20.5422 9.78747 20.6663 10.0898 20.6667C11.0885 20.6667 12.0497 19.2653 12.2321 18.9843C12.5991 18.4193 12.9425 17.7892 13.2791 17.0623C14.1268 16.7494 15.0302 16.5159 15.9058 16.2902L16.2194 16.2088C16.4551 16.1476 16.7001 16.0799 16.9514 16.0097C17.2174 15.9363 17.491 15.8601 17.769 15.7878C18.6681 16.3717 19.635 16.7526 20.5779 16.8924C21.3722 17.0104 22.0776 16.942 22.555 16.6877C22.9847 16.4592 23.0084 16.1066 22.9984 15.9656Z"
        fill={props.color || "white"}
      />
      <path
        d="M18.5332 27.8V24H21.3452V24.4994H19.1032V25.6666H20.5798V26.1497H19.1032V27.8H18.5332Z"
        fill={props.color || "white"}
      />
      <path
        d="M15.159 27.2897H15.9407C16.1398 27.2897 16.3243 27.2553 16.4944 27.1866C16.6645 27.1142 16.8129 27.0165 16.9396 26.8934C17.0699 26.7668 17.1694 26.6202 17.2381 26.4537C17.3105 26.2836 17.3467 26.099 17.3467 25.9C17.3467 25.7046 17.3105 25.5218 17.2381 25.3517C17.1694 25.1816 17.0699 25.035 16.9396 24.912C16.8129 24.7853 16.6645 24.6876 16.4944 24.6189C16.3243 24.5465 16.1398 24.5103 15.9407 24.5103H15.159V27.2897ZM14.589 27.8V24H15.9299C16.2158 24 16.48 24.0489 16.7224 24.1466C16.9649 24.2407 17.1766 24.3728 17.3576 24.5429C17.5385 24.713 17.6797 24.9138 17.781 25.1454C17.8823 25.377 17.933 25.6286 17.933 25.9C17.933 26.175 17.8823 26.4284 17.781 26.66C17.6833 26.888 17.544 27.087 17.363 27.2571C17.1821 27.4272 16.9685 27.5611 16.7224 27.6589C16.48 27.753 16.2158 27.8 15.9299 27.8H14.589Z"
        fill={props.color || "white"}
      />
      <path
        d="M11 27.8V24H12.7589C13.0086 24 13.2257 24.0489 13.4103 24.1466C13.5949 24.2407 13.7396 24.3728 13.8446 24.5429C13.9495 24.713 14.002 24.9102 14.002 25.1346C14.002 25.359 13.9495 25.5562 13.8446 25.7263C13.7396 25.8964 13.593 26.0303 13.4049 26.128C13.2203 26.2221 13.005 26.2691 12.7589 26.2691H11.57V27.8H11ZM11.57 25.786H12.6991C12.9235 25.786 13.1009 25.7281 13.2311 25.6123C13.365 25.4929 13.432 25.3354 13.432 25.14C13.432 24.9446 13.365 24.789 13.2311 24.6731C13.1009 24.5573 12.9235 24.4994 12.6991 24.4994H11.57V25.786Z"
        fill={props.color || "white"}
      />
      <path
        d="M28.3804 28.9942C28.3804 30.7146 26.8642 30.8206 26.5582 30.8241H6.99589C5.28179 30.8241 5.17858 29.2974 5.1753 28.9942L5.17507 3.00514C5.17507 1.28312 6.6941 1.17872 6.99566 1.17526H20.2104L20.2174 1.18224V6.33917C20.2174 7.3741 20.8431 9.33352 23.2126 9.33352H28.3362L28.3802 9.37744L28.3804 28.9942ZM27.1658 8.15808H23.2135C21.4999 8.15808 21.3962 6.63975 21.3939 6.33934V2.36246L27.1658 8.15808ZM29.5558 28.9942V8.89256L21.3939 0.696818V0.658686H21.3549L20.6994 0H6.99593C5.95963 0 4 0.628269 4 3.00569V28.9948C4 30.0342 4.62636 32 6.99593 32H26.5601C27.5962 31.9998 29.5558 31.3714 29.5558 28.9942Z"
        fill={props.color || "white"}
      />
    </svg>
  );
};

export const VolunteerIcon = (props) => {
  return (
    <svg
      width={props.width || "20"}
      height={props.height || "20"}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M8.8768 9.06907C7.59568 9.06907 6.54917 8.02698 6.54917 6.68381C6.54917 5.37107 7.62556 4.29856 8.8768 4.29856C10.1526 4.29856 11.2044 5.36559 11.2044 6.68381C11.2044 8.02152 10.1334 9.06907 8.8768 9.06907Z"
        stroke={props.color || "black"}
        strokeWidth="1.8"
      />
      <path
        d="M15.1528 2.45666C14.3758 2.42624 13.7482 3.03462 13.7482 3.82551V4.64683C13.808 7.56705 13.1804 9.66597 11.9551 10.7002C11.8057 10.8219 11.6263 10.974 11.4769 11.0652C10.7298 11.5824 9.86311 11.8561 8.90677 11.8561C7.80101 11.8561 6.7849 11.4607 5.978 10.7915C4.63315 11.3998 3.58716 12.5558 3.58716 14.4722V16.8753C3.58716 17.2403 3.88601 17.5445 4.24464 17.5445H13.5689C13.9275 17.5445 14.2264 17.2403 14.2264 16.8753V14.4722C14.2264 14.3505 14.2264 14.2288 14.2264 14.1071C14.1666 13.1337 14.3758 12.1603 14.8839 11.3694C15.9597 9.7268 16.4678 7.4758 16.408 4.61641V3.88635C16.408 3.1563 15.8701 2.48708 15.1528 2.45666Z"
        stroke={props.color || "black"}
        strokeWidth="1.8"
      />
    </svg>
  );
};

export const DownloadIcon = (props) => {
  return (
    <svg
      width={props.width || "20"}
      height={props.height || "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 13.6364L10 3.63635"
        stroke="white"
        stroke-width="1.6"
        stroke-linecap="round"
      />
      <path
        d="M17.2727 13.6364V15.4545C17.2727 15.9566 16.8657 16.3636 16.3637 16.3636L3.63639 16.3636C3.13431 16.3636 2.72729 15.9566 2.72729 15.4545L2.7273 13.6364"
        stroke="white"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.0001 13.6363L5.90918 9.54541"
        stroke="white"
        stroke-width="1.6"
        stroke-linecap="round"
      />
      <path
        d="M14.0909 9.54541L10 13.6363"
        stroke="white"
        stroke-width="1.6"
        stroke-linecap="round"
      />
    </svg>
  );
};
